import { Form } from 'formik';
import React from 'react';
import { Modal as BootStrapModal } from 'react-bootstrap';
import { CartStyled } from '../../../features/cart/assets/cartStyle';
import { ReactComponent as CloseIconCircled } from '../../../features/forum/assets/images/close.svg';
import { StyledCustomButton } from '../styledComponents/StyledCustomButton';
import { StyledModal } from '../styledComponents/StyledModal';
import CloseIconDefault from '../svgIcons/CloseIcon';
import { MarketplaceActivityStyled } from '../../../features/marketplaceActivity/assets/marketplaceActivityStyle';

const Modal = ({
  title,
  subTitle,
  show,
  onHide,
  centered = true,
  size = 'md',
  children,
  cancelText = 'Cancel',
  submitText = 'Submit',
  onSubmit = () => {},
  closeIconType = 'default',
  showCloseIcon = false,
  formikForm,
  hideActions,
  hideCancel,
  headerClassName,
  bodyClassName,
  badgeText,
  hideSubmitButton = false,
  ...props
}) => {
  const CloseIcon =
    closeIconType === 'default' ? CloseIconDefault : CloseIconCircled;
  const ContentWrapper = formikForm ? Form : React.Fragment;

  return (
    <StyledModal.BootStrapModal
      show={show}
      centered={centered}
      size={size}
      onHide={onHide}
      {...props}
    >
      <BootStrapModal.Body className={bodyClassName || 'p-4'}>
        {(!!title || !!subTitle || showCloseIcon) && (
          <StyledModal.Header className={headerClassName ?? 'mb-4'}>
            <CartStyled.PaymentInfo>
              {!!title && (
                <StyledModal.Title>
                  {title}
                  {(!!badgeText || badgeText === 0) && (
                    <MarketplaceActivityStyled.Category className="interested-badge ms-2 mb-0">
                      {badgeText}
                    </MarketplaceActivityStyled.Category>
                  )}
                </StyledModal.Title>
              )}
              {!!subTitle && <p>{subTitle}</p>}
            </CartStyled.PaymentInfo>
            {showCloseIcon && (
              <CloseIcon
                size={24}
                className="cursor-pointer"
                onClick={onHide}
              />
            )}
          </StyledModal.Header>
        )}

        <ContentWrapper>
          {children}

          {!hideActions && (
            <div className="d-flex align-items-center justify-content-between">
              {!hideCancel && (
                <StyledCustomButton.BtnOutlineDefault
                  className="px-4"
                  onClick={onHide}
                >
                  {cancelText}
                </StyledCustomButton.BtnOutlineDefault>
              )}
              {!hideSubmitButton && (
                <StyledCustomButton.BtnDefault
                  className="px-4"
                  type="submit"
                  onClick={onSubmit}
                >
                  {submitText}
                </StyledCustomButton.BtnDefault>
              )}
            </div>
          )}
        </ContentWrapper>
      </BootStrapModal.Body>
    </StyledModal.BootStrapModal>
  );
};

export default Modal;
